import PermissionTable from "./PermissionTable";
import { GroupedPermissions } from "../type";

const PermissionsOverview = ({
  groupedPermissions,
  setGroupedPermissions,
  isEditable,
}: {
  groupedPermissions: GroupedPermissions;
  isEditable: boolean;
  setGroupedPermissions: React.Dispatch<
    React.SetStateAction<GroupedPermissions | undefined>
  >;
}) => {
  return (
    <div className="flex flex-col gap-3">
      {Object.entries(groupedPermissions).map(
        ([category, subcategoryPermissions]) => (
          <PermissionTable
            isEditable={isEditable}
            key={category}
            category={category}
            subcategoryPermissions={subcategoryPermissions}
            setGroupedPermissions={setGroupedPermissions}
          />
        ),
      )}
    </div>
  );
};

export default PermissionsOverview;
